import { attachValidation } from './forms/validation.js';
import { handleFormSubmit } from './forms/handleSubmit.js';
import { employmentSchema } from './forms/schemas.js';

const init = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const careersForm = document.getElementById('careersForm');
    
    if (careersForm) {
      // Define error mapping for the employment form
      const errorMapping = {
        submissionType: 'error-submission-type',
        firstName: 'error-first-name',
        lastName: 'error-last-name',
        email: 'error-email',
        phone: 'error-phone',
        streetAddress: 'error-street-address',
        suburb: 'error-suburb',
        postcode: 'error-postcode',
        over18: 'error-over18',
        rsa: 'error-rsa',
        resident: 'error-resident',
        visaType: 'error-visa',
        workedBefore: 'error-worked-before',
        appliedBefore: 'error-applied-before',
        department: 'error-department',
        employmentType: 'error-employment-type',
        jobHeard: 'error-job-heard',
        whyWork: 'error-why-ft',
        hobbies: 'error-hobbies',
        cv: 'error-cv-upload',
        terms: 'error-terms'
      };

      // Attach validation to the form
      attachValidation(careersForm, employmentSchema, errorMapping, (form) => {
        handleFormSubmit(form, 'careers/apply');
      });

      // Add conditional validation for visa type field
      const residentRadios = careersForm.querySelectorAll('input[name="resident"]');
      const visaField = careersForm.querySelector('#visa');
      
      residentRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (radio.value === 'No') {
            visaField.setAttribute('required', 'required');
          } else {
            visaField.removeAttribute('required');
          }
        });
      });
    }
  });
};

export default init; 